import { render } from "./StaggeredListTransition.vue?vue&type=template&id=571e1eb1"
import script from "./StaggeredListTransition.vue?vue&type=script&lang=js"
export * from "./StaggeredListTransition.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__